module.exports = __webpack_public_path__ + "img/success-with-dg.43849021.svg";